// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ki-0";
export var discountCodeInput = "_ki-1";